import React from 'react';
import SubscribeButton from '@/creditflowresearch/ui/common/components/SubscribeButton';
import { useBwicTableContext } from '@/creditflowresearch/application/Bonds/BwicTableContext';
import { useBondsAssetClassesContext } from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';
import { useBondsSubscription } from '@/creditflowresearch/application/Bonds/useBondsSubscription';
import { getLabelContent } from '../helpers';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import type { ButtonVariant, ButtonSize } from '@creditflowresearch/uilib/Button';

interface IBwicsSubscribeButtonContainerProps {
  label?: string,
  isSubscribeAvailable: boolean,
  requiredPlan: UserPlanType,
  variant?: ButtonVariant,
  size?: ButtonSize,
}

const BwicsSubscribeButtonContainer = (props: IBwicsSubscribeButtonContainerProps) => {
  const { currentAssetClass } = useBondsAssetClassesContext();
  const { isBwicFetching: isFetching, bwicsData: { subscriptionStatus } } = useBwicTableContext();
  const { subscriptionId, isSubscribed, subscribeBySSID } = useBondsSubscription(subscriptionStatus);

  return (
    <SubscribeButton
      { ...props }
      isFetching={ isFetching }
      subscriptionId={ subscriptionId }
      isSubscribed={ isSubscribed }
      label={ getLabelContent(subscriptionStatus.isSubscribed, currentAssetClass?.abbreviation) }
      subscribeBySSID={ subscribeBySSID }
    />
  );
};

export default BwicsSubscribeButtonContainer;
